import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import shortNames from 'src/consts/filtersShortNames.json';
import 'src/components/Search/Autocomplete/AutocompleteTokens.scss';


const labelToJSX = label => (typeof label === 'string'
  ? label
  : label.map(({ part }) => part).join(''));

const AutocompleteTokens = ({ actions, tokens }) => {
  const tokensList = tokens.map((item) => {
    const tokenDataTest = `token-${item.name}`;
    const tokenKey = `autocomplete-wiener-${item.name}-${item.value}`;
    return (
      <span
        key={ tokenKey }
        data-test={ tokenDataTest }
        styleName="token"
      >
        <input name={ shortNames[item.name] } readOnly type="hidden" value={ item.value } />
        { labelToJSX(item.label) }
        <button
          className="mdi mdi-close"
          data-test="button-close-token"
          onClick={ () => { actions.removeTag(item); } }
          styleName="token__icon"
          type="button"
        />
      </span>
    );
  });
  return (
    <Fragment>
      {tokensList}
    </Fragment>
  );
};

const tokensProperties = PropTypes.shape({
  label: PropTypes.oneOfType([
    PropTypes.string, PropTypes.array
  ]),
  name: PropTypes.string,
  value: PropTypes.string
});

AutocompleteTokens.propTypes = {
  actions: PropTypes.shape({
    removeTag: PropTypes.func
  }),
  tokens: PropTypes.arrayOf(tokensProperties)
};

AutocompleteTokens.defaultProps = {
  actions: {},
  tokens: []
};

export default AutocompleteTokens;
